export { default } from "./Freelancer";
